//import "./js/slider";
import "./js/tabs";

import "./sass/style.scss";
